export default "__VITE_ASSET__mVyQfMuh__"